module.exports = __webpack_public_path__ + "img/team-registration-symbol.a1dfcdda.svg";